module.exports = __webpack_public_path__ + "static/stats-b2776bc11b54602ce86f13f00b43dba8.svg";